import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class LMRelatedReportService {

  constructor(private http: HttpClient) {
  }

  public getRelatedReports(relatedReportUrl: any): Observable<LMRelatedReports> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json;charset=utf-8');
    return this.http.get<LMRelatedReports>(relatedReportUrl, { headers });
  }

}

export interface RelatedReportParams {
  sourceResourceUrl: string;
  listTitle: string;
}
